import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import getClassName from 'src/common/utils/getClassName';
import s from './CheckDecorator.module.scss';

const CheckDecorator: FC<Props> = ({
  children,
  disabled,
}) => (
  <span className={s.root}>
    {children}
    <span className={getClassName(s, 'checkMark', classNames({ disabled }))} />
  </span>
);

type Props = {
  children: ReactNode;
  disabled?: boolean;
};

export default CheckDecorator;
